import { getMessageText } from './AssistantProvider';

const UserMessage = ({ message }) => {
    const text = getMessageText(message);

    return (
        <div
            className="self-end max-w-[90%] md:max-w-[80%]"
            data-message-role="user"
            data-message-id={message.id}
        >
            <div className="px-3.5 py-2.5 rounded-xl text-sm leading-relaxed whitespace-pre-wrap bg-[#1B1A2E] text-white rounded-br-sm">
                {text}
            </div>
        </div>
    );
};

export default UserMessage;
